import React, {ChangeEvent, useCallback} from 'react';
import {SearchOutlined} from '@ant-design/icons';
import {Input} from 'antd';

//import {useDebounce} from '../../../hooks/useDebounce';

import styles from './Search.module.scss';

export type SearchProps = {
  value: string;
  onValueChange: (value: string) => any;
  debounce?: number;
  placeholder?: string;
  width?: 'full';
  onPressEnter?: () => void;
  tourId?: string;
};

export const Search: React.FC<SearchProps> = ({placeholder, value, onValueChange, width, onPressEnter, tourId}) => {
  const handleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      onValueChange(event.target.value);
    },
    [onValueChange],
  );

  return (
    <Input
      data-tour-id={tourId}
      value={value}
      placeholder={placeholder ? placeholder : 'What are you looking for today?'}
      onChange={(event) => handleChange(event)}
      onPressEnter={onPressEnter}
      allowClear
      className={width === 'full' ? styles.commonSearch : styles.modelSearch}
      prefix={<SearchOutlined />}
      style={{outline: 'none', boxShadow: 'none', width: width === 'full' ? '100%' : '609px'}}
    />
  );
};
